import { RelationshipTypeENUM } from '../../enums/ProductEnums';
import { ProductDTO } from '../DTOs/ProductDTO';
import { ProductRelationShipDTO } from '../DTOs/ProductRelationshipDTO';
import { AttributeSettings } from './AttributeSettings';
import { Connector } from './Connector';
import { Product } from './Product';
import { IdMapper, ProductBlueprint } from './ProductBlueprint';
import { TransformationData } from './TransformationData';

export class ProductRelationship {
  public static getEmptyProductRelationship(relationshipType: RelationshipTypeENUM) {
    return new ProductRelationship(
      undefined,
      undefined,
      new TransformationData(undefined, [0, 0, 0], [0, 0, 0]),
      relationshipType,
      false,
      undefined,
      false,
    );
  }

  public static fromDTO(productRelationShipDTO: ProductRelationShipDTO, availibleBlueprints?: ProductBlueprint[]) {
    let childProduct: Product | string | undefined;

    if (productRelationShipDTO.relationshipType === RelationshipTypeENUM.ParentRelationship) {
      if (!availibleBlueprints) {
        throw new Error('PoductRelationship that contains a Product, requires availibleBlueprints to be provided');
      }

      childProduct = Product.fromDTO(productRelationShipDTO.childProduct as ProductDTO, availibleBlueprints);
    } else {
      if (productRelationShipDTO.childProduct !== null || productRelationShipDTO.childProduct !== undefined) {
        childProduct = productRelationShipDTO.childProduct.toString();
      } else childProduct = undefined;
    }

    let connectors: Connector[] = [];
    if (productRelationShipDTO.connectors) {
      connectors = productRelationShipDTO.connectors.map((connector) => Connector.fromDTO(connector));
    }

    if (productRelationShipDTO.ignoreCollision === undefined) {
      productRelationShipDTO.ignoreCollision = false;
    }
    return new ProductRelationship(
      productRelationShipDTO.id?.toString(),
      childProduct,
      productRelationShipDTO.transformationData
        ? TransformationData.fromDTO(productRelationShipDTO.transformationData)
        : TransformationData.getEmptyTransformationData(),
      productRelationShipDTO.relationshipType,
      productRelationShipDTO.addedByDefault,
      connectors,
      productRelationShipDTO.ignoreCollision,
      productRelationShipDTO.parentAttributeOverride
        ? productRelationShipDTO.parentAttributeOverride.map((attributeSettingDTO) =>
            AttributeSettings.fromDTO(attributeSettingDTO),
          )
        : [],
      productRelationShipDTO.childAttributeOverride
        ? productRelationShipDTO.childAttributeOverride.map((attributeSettingDTO) =>
            AttributeSettings.fromDTO(attributeSettingDTO),
          )
        : [],
    );
  }

  id?: string;
  childProduct: Product | ProductBlueprint | string | undefined; //If it is a product blueprint, it will be string at first and later set by passing in an array of productBlueprints
  transformationData: TransformationData;
  relationShipType: RelationshipTypeENUM;
  addedByDefault: boolean;
  connectors: Connector[];
  ignoreCollision: boolean;
  parentAttributeOverride: AttributeSettings[];
  childAttributeOverride: AttributeSettings[];

  constructor(
    id: string | undefined | undefined,
    childProduct: Product | ProductBlueprint | string | undefined,
    transformationData: TransformationData,
    relationShipType: RelationshipTypeENUM,
    addedByDefault: boolean,
    connectors: Connector[] = [],
    ignoreColision: boolean,
    parentAttributeOverride: AttributeSettings[] = [],
    childAttributeOverride: AttributeSettings[] = [],
  ) {
    this.id = id;
    this.childProduct = childProduct;
    this.transformationData = transformationData;
    this.relationShipType = relationShipType;
    this.addedByDefault = addedByDefault;
    this.connectors = connectors;
    this.ignoreCollision = ignoreColision;
    this.parentAttributeOverride = parentAttributeOverride;
    this.childAttributeOverride = childAttributeOverride;
  }

  public populateProductBlueprintReferences(availibleBlueprints: ProductBlueprint[], idMapper: IdMapper) {
    if (this.childProduct instanceof ProductBlueprint || this.childProduct instanceof Product || !this.childProduct) {
      return;
    }

    let foundProductBlueprint = idMapper.productBlueprintMap.get(this.childProduct);

    if (!foundProductBlueprint) {
      foundProductBlueprint = availibleBlueprints.find((productBlueprint) => productBlueprint.id === this.childProduct);
    }

    if (foundProductBlueprint) idMapper.productBlueprintMap.set(this.childProduct, foundProductBlueprint);

    /* if (!foundProductBlueprint) {
      throw new Error('Could not populate product relationship, because blueprint was not in availible blueprints');
    } */

    this.childProduct = foundProductBlueprint;

    for (const connector of this.connectors) {
      connector.populateProductBlueprintReferences(availibleBlueprints, idMapper);
    }
    for (const attributeSetting of this.childAttributeOverride) {
      attributeSetting.populateWithAttributes(availibleBlueprints, idMapper);
    }
    for (const attributeSetting of this.parentAttributeOverride) {
      attributeSetting.populateWithAttributes(availibleBlueprints, idMapper);
    }
  }

  public toDTO(): ProductRelationShipDTO {
    let childProductDTO: number | ProductDTO;

    if (this.childProduct instanceof Product) {
      childProductDTO = this.childProduct.toDTO();
    } else if (this.childProduct instanceof ProductBlueprint) {
      childProductDTO = Number(this.childProduct.id);
    } else {
      childProductDTO = Number(this.childProduct);
    }

    return new ProductRelationShipDTO(
      Number(this.id) || undefined,
      childProductDTO,
      this.transformationData.toDTO(),
      this.relationShipType,
      this.addedByDefault,
      [], // TODO: implement this
      this.ignoreCollision,
    );
  }

  public dispose() {
    if (this.childProduct instanceof ProductBlueprint) {
      this.childProduct.dispose();
    }
  }
}
